// extracted by mini-css-extract-plugin
module.exports = {"mecha":"index-mecha-3EBen","btnDetail":"index-btnDetail-3GTkQ"};